<template>
  <div class="fivestep-wrap">
    <div class="auto">
      <div class="gift-box">
        <p><span>购买</span> 大智慧策略投资终端 - 年卡 <span>或 </span>钜惠大礼包产品年卡</p>
        <p class="margin"><span>赠</span><strong>《牛年五步战法》</strong><em class="btn-buy" @click="goUrl(113)"></em></p>
        <p><span>另赠  [马太效应模型]、[慧眼三步战法]。</span></p>
        <p class="time">活动期限：3月1日至4月30日</p>
        <p class="tel">领取热线：021-20219999</p>
      </div>
      <div class="info-box">
        <span>《牛年五步战法》</span>
        <p>是一个将大智慧近年新研发的ACE资金、AI资金线、主力风向标等多项资金流向功能巧融为一体；辅助策略投资终端高净值用户构建自己的盈利体系的全新战法。</p>
      </div>
      <div class="mod mod1">
        <h2 class="title"></h2>
        <p>2月1日，002714牧原股份《牛年五步战法》发出多策略共振信号之后  8个交易日累计涨幅为40.62%，股价持续创新高！</p>
      </div>
      <div class="mod mod2">
        <p>2月3日003000 华文食品《牛年五步战法》发出多策略共振信号之后，3个交易日累计最高涨幅33.1%</p>
      </div>
       <div class="mod mod3">
        <p>2月3日000488晨鸣纸业 《牛年五步战法》发出多策略共振信号之后，7个交易日累计最高涨幅43.20%</p>
      </div>
      <p class="emphasize">大智慧专注资金流向数据的研究，多年的技术沉淀，值得用户信赖。</p>
      <div class="buy-box">
        <span class="btn-buy" @click="goUrl(113)"></span>
        <p>领取热线：021-20219999</p>
      </div>
    </div>
    <div class="footer">
      <div class="auto">
        <p><em>免责提醒：</em><span>盘中的选股预警等监控，是筛选当时满足条件的股票自动进入预警和条件选股结果，无人为干预。任何筛选都不可能避免系统风险和个股风
                       险，指标工具仅供参考，投资者需理性决策，责任自负！案例仅供参考，不构成推荐股票！投资有风险，入市需谨慎！</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      token: ''
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods: {
    goUrl (key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month:12}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    }
  },
}
</script>

<style lang="scss" scoped>
  .fivestep-wrap{
    background: url(../../assets/images/activity/fivestep2021/bg1.jpg) no-repeat center 0,
                url(../../assets/images/activity/fivestep2021/bg2.jpg) no-repeat center 641px #bc022b;
    padding-top: 825px;
    position: relative;
    min-width: 1200px;
    // &:after{
    //   content: '';
    //   display: block;
    //   @include wh(293px, 621px);
    //   position: absolute;
    //   right: 0;
    //   top: 1290px;
    //   background: url(../../assets/images/activity/fivestep2021/flower.png) no-repeat
    // }
  }
  .auto{
    @include auto(1200px);
    overflow: hidden;
  }
  .gift-box{
    p{
      text-align: center;
      @include fc(36px, #fff);
      &.margin{
        margin: 25px 0 -10px;
      }
      &.time{
        text-align: right;
        font-size: 20px;
        margin: 28px 50px 80px 0;
      }
      &.tel{
        font-size: 30px;
        color: #ffad59;
      }
      span{
        color: #ffad59;
      }
      .btn-buy{
        background: url(../../assets/images/activity/fivestep2021/btn-buy1.png) no-repeat;
        @include wh(354px, 136px);
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
  .info-box{
    overflow: hidden;
    background: url(../../assets/images/activity/fivestep2021/info-bg.png) no-repeat;
    @include wh(1200px, 270px);
    @include fc(30px, #ffca9e);
    margin: 50px 0 135px;
    padding: 60px 0px 0 45px;
    box-sizing: border-box;
    span{
      float: left;
      font-size: 36px;
    }
    p{
      float: left;
      width: 810px;
      text-align: justify;
    }
  }
  .mod{
    position: relative;
    border-radius: 20px;
    box-sizing: border-box;
    p{
      @include fc(30px, #ffca9e);
      line-height: 48px;
    }
    &:before,&:after{
      content: '';
      display: block;
      width: 76px;
      height: 57px;
      position: absolute;
    }
    &:before{
       left: -76px;
    }
    &:after{
       right: -76px;
    }
  }
  .mod1{
    background: url(../../assets/images/activity/fivestep2021/img1.png) no-repeat;
    padding: 85px 50px 0;
    height: 1042px;
    .title{
      background: url(../../assets/images/activity/fivestep2021/title.png) no-repeat;
      width: 593px;
      height: 199px;
      @include center-box-x;
      top: -100px;
    }
    &:before{
      background: url(../../assets/images/activity/fivestep2021/tag1.png) no-repeat;
      top: 38px;
    }
    &:after{
      background: url(../../assets/images/activity/fivestep2021/tag2.png) no-repeat;
      right: -76px;
      bottom: 38px;
    }
  }
  .mod2{
    background: url(../../assets/images/activity/fivestep2021/img2.png) no-repeat;
    padding: 50px 50px 0;
    height: 823px;
    margin: 30px 0;
    &:before{
      top: 740px;
      background: url(../../assets/images/activity/fivestep2021/tag1.png) no-repeat;
    }
  }
  .mod3{
    background: url(../../assets/images/activity/fivestep2021/img3.png) no-repeat;
    padding: 50px 50px 0;
    height: 1012px;
    &:after{
      bottom: 38px;
      background: url(../../assets/images/activity/fivestep2021/tag2.png) no-repeat;
    }
  }
  .emphasize{
    @include fc(40px, #ffb071);
    text-shadow: 0 3px 3px #75001a;
    text-align: center;
    margin: 45px 0 100px;
  }
  .buy-box{
    background: url(../../assets/images/activity/fivestep2021/btn-buy2.png) no-repeat;
    position: relative;
    padding: 245px 0 45px;
    .btn-buy{
      position: absolute;
      @include wh(920px, 132px);
      left: 146px;
      top: 89px;
      cursor: pointer;
    }
    p{
      text-align: center;
      @include fc(30px, #f9b5a1);
    }
  }
  .footer{
    background: #9a0023;
    padding: 30px 0;
    p{
      @include fc(18px, #d98364);
      overflow: hidden;
      em{
        float: left;
      }
      span{
        float: left;
        margin-left: 3px;
        width: 1090px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/activity/FiveStep2021.vue